import React from 'react';
import Webcam from "react-webcam";
import autoBind from "react-autobind";
import RecordRTC from "recordrtc";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import {
	Button
} from "react-bootstrap";
import _ from "lodash";
import ModeButtons from "./modeButtons";
import { showError2 } from "../../actions/alertActions";
import { isEdge } from "../../utils/browserUtils";


class Camera extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);

		this.state = {
			mode: this.props.mode ? this.props.mode : "image",
			preview: false,
			cameraInitialized: false,
			video: {
				recording: false
			},
			image: {
			},
			videoSupported: isEdge() ? false: true
		}
	}

	componentWillUnmount() {
		clearInterval(this.webcamLoadInterval);
	}

	handleChangeMode(mode) {

		if (this.state.mode === "video" && mode !== "video") {
			this.clearRecorderData();
		}

		this.setState({
			mode: mode,
			preview: false
		});
	}

	takeScreenshot() {
		const imageSrc = this.webcam.getScreenshot();

		if (imageSrc !== null) {
			this.setState({
				preview: true,
				image: {
					imagePreviewSrc: imageSrc
				}
			});
		}
	}

	startRecording() {
		let stream = this.webcam.stream;

		let recorder = new RecordRTC(stream, {
			type: "video",
			mimeType: "video/webm;codecs=h264"
		});
		recorder.startRecording();

		this.setState({
			video: {
				recorder: recorder,
				recording: true
			}
		});		
	}

	stopRecording() {
		let recorder = this.state.video.recorder;
		recorder.stopRecording(() => {
			this.setState({
				preview: true,
				video: {
					recording: false,
					recorder: recorder,
					videoPreviewUrl: recorder.toURL()
				}
			});
		});
	}

	handleAcceptVideo() {
		let recorder = this.state.video.recorder;

		if (this.props.onAccept) {
			this.props.onAccept({
				type: "video",
				blob: recorder.getBlob()
			});
		}
	}

	handleRetakeVideo() {
		let self = this;
		this.clearRecorderData().then(() => {
			self.setState({
				preview: false,
				video: {
					recording: false,
					recorder: undefined
				}
			});
		}).catch((err) => {
			// console.log(err);
			showError2("Failed to clear recorder data.", err);
		});
	
	}

	handleAcceptImage() {
		if (this.props.onAccept) {
			this.props.onAccept({
				type: "image",
				data: this.state.image.imagePreviewSrc
			})
		}
	}

	handleRetakeImage() {
		this.setState({
			preview: false,
			image: {
				imagePreviewSrc: undefined
			}
		})
	}

	clearRecorderData() {
		let recorder = _.get(this.state, "video.recorder");
		let self = this;

		return new Promise((resolve, reject) => {
			if (!_.isUndefined(recorder)) {
				if (recorder.state === "recording") { 
					recorder.stopRecording(() => {
						recorder.clearRecordedData();
						self.setState({
							video: {
								recording: false
							}
						})
						resolve();
					});
				} else {
					recorder.clearRecordedData();
					self.setState({
						video: {
							recording: false
						}
					})
					resolve();
				}
			} else {				
				self.setState({
					video: {
						recording: false
					}
				})
				resolve();
			}
		});
	}

	onUserMedia() {
		let self = this;
		let video = _.get(this.webcam,"video");
				
		clearInterval(self.webcamLoadInterval);

		if (!_.isUndefined(video)) {
			self.webcamLoadInterval = setInterval(function () {
				//check if video is ready to play before enabling capture controls
				if (video.readyState === 4) {
					clearInterval(self.webcamLoadInterval);
					self.setState({
						cameraInitialized: true
					})
				}
			}, 50);
		}		
	}

	onVideoPreviewLoaded() {
		let video = this.state.video;

		let newVideo = _.clone(video);
		newVideo.previewLoaded = true;
		this.setState({
			video: newVideo
		});
	}

	render() {

		return (
			<div className="camera-container">
				<div style={{display: (this.state.preview) ? "none": "block"}}>
					{this.renderCapture()}
				</div>			
				{(this.state.preview) ? this.renderPreview(): null}	
			</div>
		)
	}


	renderCapture() {
		let { videoSupported, mode, cameraInitialized } = this.state;
		let modeButtons = (this.props.showModeSelector) ? <ModeButtons mode={this.state.mode} onChangeMode={this.handleChangeMode} /> : null;

		let controls = (this.state.mode === "video") ? this.renderVideoCaptureControls() : this.renderImageCaptureControls();

		let view = <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
			<div style={{ position: "relative", minHeight: "480px" }}>
				<Webcam ref={e => this.webcam = e} onUserMedia={this.onUserMedia} screenshotFormat={"image/png"} screenshotWidth={1280} screenshotHeight={720} width="100%" height="inherit"/>
				<div style={{
					display: (cameraInitialized === true) ? "none" : "flex",
					position: "absolute", left: 0, top: 0, width: "100%", height: "100%", flexDirection: "row", alignItems: "center", justifyContent: "center", backgroundColor: "white"
				}}>Initializing camera ...</div>
				<div style={{
					display: (cameraInitialized === true && mode === "video" && videoSupported === false) ? "flex" : "none",
					position: "absolute", left: 0, top: 0, width: "100%", height: "100%", flexDirection: "row", alignItems: "center", justifyContent: "center", backgroundColor: "white", opacity: ".8"
				}}>Video capture is not supported by your browser.</div>
			</div>
			{modeButtons}
			{controls}
		</div>

		return view;
	}

	renderVideoCaptureControls() {
		let { video, cameraInitialized, videoSupported } = this.state;

		let opacity = 1;
		if (!cameraInitialized || videoSupported === false) {
			opacity = .3;
		}

		if (video.recording) {			
			return <div style={{ color: "#a3a3a3", fontSize: "48px", opacity }}><FontAwesomeIcon onClick={(e) => { if (cameraInitialized && videoSupported) this.stopRecording() }} icon="stop-circle" style={{ cursor: "pointer" }} /></div>;
		} else {
			return <div style={{ color: "red", fontSize: "48px", opacity }}><FontAwesomeIcon icon={["fas", "circle"]} onClick={(e) => { if (cameraInitialized && videoSupported) this.startRecording()}} style={{ cursor: "pointer" }} /></div>
		}
	}

	renderImageCaptureControls() {
		let { cameraInitialized } = this.state;

		let opacity = 1;
		if (!cameraInitialized) {
			opacity = .3;
		}

		return <div style={{ color: "#a3a3a3", fontSize: "48px", opacity }}><FontAwesomeIcon icon={["fas", "camera"]} onClick={(e) => { if (cameraInitialized) this.takeScreenshot() }} style={{ cursor: "pointer" }} /></div>;
	}

	renderPreview() {
		if (this.state.mode === "video") {
			return this.renderVideoPreview();
		} else {
			return this.renderImagePreview();
		}
	}

	renderVideoPreview() {
		let previewVideoVisibility = (this.state.video.previewLoaded) ? "visible" : "hidden";

		return (
			<div style={{ display: "flex", flexDirection: "column" }}>
				<div style={{ minHeight: "480px", width: "100%"}}>
					<video src={this.state.video.videoPreviewUrl} controls width="100%" style={{ visibility: previewVideoVisibility }} onLoadedData={this.onVideoPreviewLoaded}/>
				</div>
				<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: "12px" }}>
					<Button onClick={this.handleRetakeVideo}>Retake</Button>
					<Button onClick={this.handleAcceptVideo} bsStyle="primary">Accept</Button>
				</div>
			</div>
		)
	}

	renderImagePreview() {
		return (
			<div style={{ display: "flex", flexDirection: "column" }}>
				<div style={{minHeight: "480px"}}>
					<img alt="" src={this.state.image.imagePreviewSrc} style={{ maxWidth: "640px", width: "100%" }}/>
				</div>
				<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: "12px" }}>
					<Button onClick={this.handleRetakeImage}>Retake</Button>
					<Button onClick={this.handleAcceptImage} bsStyle="primary">Accept</Button>
				</div>
			</div>
		);
	}

}

export default Camera;